module.exports = __webpack_public_path__ + "static/media/icon_discount.26a44786.svg";